// ============================================================
// ARCHIVO DE CONTENIDO EDITABLE - CONFIARÉ
// ============================================================
// 
// 📝 INSTRUCCIONES:
// Este archivo contiene TODO el contenido editable del sitio.
// Puedes modificar textos, teléfonos, enlaces, imágenes, etc.
// sin tocar el código de los componentes.
//
// ⚠️ IMPORTANTE:
// - No borres las comillas "" de los textos
// - No borres las comas al final de cada línea
// - No cambies los nombres de las propiedades (ej: title, description)
// - Los cambios se verán después de recompilar (yarn build)
//
// ============================================================

const siteContent = {

  // ============================================================
  // 🔍 SEO Y METADATOS
  // ============================================================
  seo: {
    title: "CONFIARÉ - Tu Aliado Financiero de Confianza",
    description: "Créditos personales, empresariales y factoraje en Ciudad Juárez. Aprobación rápida, asesoría gratuita y atención personalizada.",
    keywords: "créditos personales, créditos empresariales, factoraje, financiera, préstamos, Ciudad Juárez, Chihuahua, CONFIARÉ",
    ogImage: "/images/logo-confiare.png",
    siteUrl: "https://confiare.mx"
  },

  // ============================================================
  // 📞 INFORMACIÓN DE CONTACTO
  // ============================================================
  contact: {
    phone: "(656) 536-7364",
    phoneLink: "tel:6565367364",
    email: "credito@confiare.mx",
    address: "Boulevard Manuel Gómez Morín #8016, Local 7, Col. Sandra Lucia, C.P 32530, Ciudad Juárez, Chihuahua",
    hours: "Lunes a Viernes: 9:00 AM - 6:00 PM",
    
    // WhatsApp
    whatsapp: {
      number: "526561975200",
      defaultMessage: "Hola, me interesa información sobre sus créditos",
      // Genera el link automáticamente, no editar esta línea
      get link() {
        return `https://wa.me/${this.number}?text=${encodeURIComponent(this.defaultMessage)}`;
      }
    },

    // Google Maps
    mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3396.8088744661!2d-106.42876492342!3d31.74944997416!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86e75975830a7b55%3A0x3c5d8a3b3c5d8a3b!2sBlvd.%20Manuel%20G%C3%B3mez%20Mor%C3%ADn%208016%2C%20Sandra%20Luc%C3%ADa%2C%2032530%20Ju%C3%A1rez%2C%20Chih.%2C%20Mexico!5e0!3m2!1sen!2sus!4v1709669600000!5m2!1sen!2sus",
    mapDirectionsUrl: "https://www.google.com/maps/search/?api=1&query=Boulevard+Manuel+Gomez+Morin+8016+Sandra+Lucia+Ciudad+Juarez+Chihuahua+Mexico"
  },

  // ============================================================
  // 🌐 REDES SOCIALES
  // ============================================================
  socialLinks: {
    facebook: "https://www.facebook.com/confiare.creditos",
    instagram: "https://www.instagram.com/confiare.mx",
    tiktok: "https://www.tiktok.com/@confiare.mx"
  },

  // ============================================================
  // 🔗 ENLACES INSTITUCIONALES
  // ============================================================
  institutionalLinks: {
    buro: {
      name: "Buró de Entidades Financieras",
      url: "https://www.buro.gob.mx/",
      logo: "/images/logo-buro.png"
    },
    condusef: {
      name: "CONDUSEF",
      url: "https://www.condusef.gob.mx/",
      logo: "/images/logo-condusef.png"
    }
  },

  // ============================================================
  // 🖼️ IMÁGENES
  // ============================================================
  images: {
    logo: "/images/logo-confiare.png",
    logoWhite: "/images/logo-confiare-blanco.png",
    hero: "/images/hero-imagen.png",
    about: "/images/about-profesional.jpg",
    office: "/images/oficina-confiare.jpg"
  },

  // ============================================================
  // 🏠 SECCIÓN HERO (Principal)
  // ============================================================
  hero: {
    title: "Recibe el apoyo que necesitas,",
    titleHighlight: "justo cuando lo necesitas",
    subtitle: "Créditos flexibles, seguros y a tu medida. Confiar en ti es nuestra especialidad.",
    
    // Características destacadas
    features: [
      "Aprobación en 24 hrs",
      "Asesoría gratuita"
    ],
    
    // Botones
    primaryButton: {
      text: "Solicita tu crédito ahora",
      // Mensaje de WhatsApp para este botón
      whatsappMessage: "Hola, me interesa solicitar un crédito"
    },
    secondaryButton: {
      text: "Conoce nuestros créditos",
      scrollTo: "creditos"
    },

    // Card de crédito aprobado
    creditCard: {
      title: "Tu crédito aprobado",
      label: "Monto disponible",
      amount: "$150,000",
      successTitle: "¡Felicidades!",
      successText: "Crédito aprobado"
    }
  },

  // ============================================================
  // 💳 PRODUCTOS / CRÉDITOS
  // ============================================================
  products: {
    sectionLabel: "NUESTROS PRODUCTOS",
    sectionTitle: "Soluciones financieras a tu medida",
    sectionSubtitle: "Encuentra el crédito perfecto para tus necesidades",
    
    // Lista de productos
    items: [
      {
        id: 1,
        title: "Crédito Personal",
        description: "Rápido y sin complicaciones. Uso libre para lo que necesites.",
        image: "/images/credito-personal.jpg",
        features: [
          "Planes personalizados a tus necesidades",
          "Asesoría gratuita",
          "Sin compromisos"
        ],
        buttonText: "Solicitar ahora",
        whatsappMessage: "Hola, me interesa información del producto Crédito Personal"
      },
      {
        id: 2,
        title: "Negocios",
        description: "Impulsa el crecimiento de tu negocio.",
        image: "/images/negocios.jpg",
        features: [
          "Planes personalizados a tus necesidades",
          "Asesoría gratuita",
          "Sin compromisos"
        ],
        buttonText: "Solicitar ahora",
        whatsappMessage: "Hola, me interesa información del producto Negocios"
      },
      {
        id: 3,
        title: "Tratamientos médicos",
        description: "Financiamiento para cubrir gastos de salud de forma rápida y confiable.",
        image: "/images/credito-nomina.jpg",
        features: [
          "Planes personalizados a tus necesidades",
          "Asesoría gratuita",
          "Sin compromisos"
        ],
        buttonText: "Solicitar ahora",
        whatsappMessage: "Hola, me interesa información del producto Tratamientos médicos"
      },
      {
        id: 4,
        title: "Crédito Empresarial",
        description: "Somos el respaldo financiero que tu empresa necesita.",
        image: "/images/credito-empresarial.jpg",
        features: [
          "Crédito para deudas",
          "Adquisición de maquinarias",
          "Compra de insumos"
        ],
        buttonText: "Solicitar ahora",
        whatsappMessage: "Hola, me interesa información del producto Crédito Empresarial"
      },
      {
        id: 5,
        title: "Factoraje",
        description: "Convierte tus facturas por cobrar en liquidez inmediata, sin adquirir deuda adicional.",
        image: "/images/factoraje.png",
        features: [
          "Liquidez inmediata sin esperar 60 días",
          "Sin adquirir deuda adicional",
          "Recibe tu dinero hoy"
        ],
        buttonText: "Solicitar ahora",
        whatsappMessage: "Hola, me interesa información del producto Factoraje"
      }
    ]
  },

  // ============================================================
  // ✨ BENEFICIOS
  // ============================================================
  benefits: {
    sectionLabel: "¿Por qué elegirnos?",
    sectionTitle: "Beneficios que nos distinguen",
    sectionSubtitle: "En CONFIARÉ nos comprometemos a brindarte la mejor experiencia financiera",
    
    items: [
      {
        title: "Crédito a tu medida",
        description: "Adaptamos el financiamiento a tus necesidades específicas.",
        icon: "Target"
      },
      {
        title: "Sin letras chiquitas",
        description: "Transparencia total en cada paso del proceso.",
        icon: "FileCheck"
      },
      {
        title: "Atención presencial",
        description: "Te atendemos directamente en nuestras oficinas.",
        icon: "Building"
      },
      {
        title: "Atención personalizada",
        description: "Un asesor dedicado te acompaña en todo momento.",
        icon: "HeadphonesIcon"
      }
    ]
  },

  // ============================================================
  // 👥 SECCIÓN QUIÉNES SOMOS
  // ============================================================
  about: {
    sectionLabel: "Nuestra historia",
    sectionTitle: "Más que una financiera,",
    sectionTitleHighlight: "tu aliado de confianza",
    description: "CONFIARÉ es una institución financiera que cree en las personas. Nuestro compromiso es brindarte el apoyo financiero que mereces, con transparencia y cercanía.",
    
    // Valores de la empresa
    values: [
      { name: "Confianza", icon: "Shield" },
      { name: "Transparencia", icon: "Eye" },
      { name: "Compromiso", icon: "Heart" },
      { name: "Innovación", icon: "Sparkles" }
    ]
  },

  // ============================================================
  // 📋 PROCESO
  // ============================================================
  process: {
    sectionLabel: "Proceso simple",
    sectionTitle: "Obtén tu crédito en 3 pasos",
    sectionSubtitle: "Sin afectar tu buró, rápido y con asesoría personalizada",
    
    steps: [
      {
        step: "01",
        title: "Contáctanos por WhatsApp",
        description: "Escríbenos y cuéntanos qué necesitas. Estamos listos para atenderte."
      },
      {
        step: "02",
        title: "Recibe asesoría personalizada",
        description: "Un asesor te guiará en todo el proceso y resolverá tus dudas."
      },
      {
        step: "03",
        title: "¡Listo! Tu crédito aprobado",
        description: "Obtén tu crédito de forma rápida y segura."
      }
    ],

    buttons: {
      primary: "Inicia tu solicitud",
      secondary: "Habla con un asesor"
    }
  },

  // ============================================================
  // ❓ PREGUNTAS FRECUENTES
  // ============================================================
  faq: {
    sectionLabel: "FAQ",
    sectionTitle: "Preguntas frecuentes",
    sectionSubtitle: "Resolvemos tus dudas más comunes",
    
    items: [
      {
        question: "¿Cuáles son los requisitos para solicitar un crédito?",
        answer: "Los requisitos básicos son: identificación oficial vigente, comprobante de domicilio reciente, comprobante de ingresos y referencias personales. Dependiendo del tipo de crédito, pueden variar."
      },
      {
        question: "¿Cuánto tiempo tarda la aprobación?",
        answer: "Nuestro proceso es rápido. Una vez que completas tu solicitud con todos los documentos, puedes recibir una respuesta en menos de 24 horas hábiles."
      },
      {
        question: "¿Qué tasas de interés manejan?",
        answer: "Nuestras tasas son competitivas y varían según el tipo de crédito y tu perfil. Un asesor te proporcionará información detallada y personalizada."
      },
      {
        question: "¿Puedo pagar mi crédito anticipadamente?",
        answer: "Sí, puedes realizar pagos anticipados sin penalización. Esto te ayudará a reducir el costo total de tu crédito."
      },
      {
        question: "¿Qué pasa si tengo mal historial crediticio?",
        answer: "En CONFIARÉ evaluamos cada caso de manera individual. Aunque tengas un historial crediticio complicado, podemos encontrar opciones para ti."
      }
    ]
  },

  // ============================================================
  // 🏛️ UNE (Unidad Especializada)
  // ============================================================
  une: {
    sectionLabel: "UNE",
    sectionTitle: "Unidad Especializada de Atención a Usuarios",
    description: "En caso de alguna consulta, reclamación o aclaración, podrá presentarla en la UNE de atención a usuarios, la que dará respuesta en un plazo no mayor a 30 días hábiles.",
    
    titular: {
      title: "Titular de la Unidad y Encargado Regional",
      name: "Yadira Guadalupe Holguin Lara"
    },
    
    schedule: "Lunes a viernes de 8:00 am a 2:00 pm y de 3:00 a 6:00 pm",
    phone: "(656) 536 73 64",
    phoneLink: "tel:6565367364"
  },

  // ============================================================
  // 📝 FORMULARIO DE CONTACTO
  // ============================================================
  contactForm: {
    title: "Envíanos un mensaje",
    
    // Labels y placeholders
    fields: {
      name: {
        label: "Nombre completo",
        placeholder: "Tu nombre"
      },
      phone: {
        label: "Teléfono",
        placeholder: "55 1234 5678"
      },
      email: {
        label: "Correo electrónico",
        placeholder: "tu@email.com"
      },
      creditType: {
        label: "Tipo de crédito",
        placeholder: "Selecciona una opción",
        options: [
          { value: "personal", label: "Crédito Personal" },
          { value: "empresarial", label: "Crédito Empresarial" },
          { value: "factoraje", label: "Factoraje" }
        ]
      },
      message: {
        label: "Mensaje",
        placeholder: "Cuéntanos cómo podemos ayudarte..."
      }
    },
    
    submitButton: "Enviar mensaje",
    submittingText: "Enviando...",
    privacyText: "Al enviar este formulario, aceptas nuestro",
    privacyLinkText: "Aviso de Privacidad",
    
    // Mensajes de respuesta
    successMessage: "Gracias por contactarnos. Un asesor se pondrá en contacto contigo pronto.",
    errorMessage: "Hubo un error al enviar el formulario. Por favor intenta de nuevo o contáctanos por WhatsApp.",

    // Endpoint del formulario (null = modo demo)
    // Cambia esto por tu endpoint real, ej: "https://formspree.io/f/TU_ID"
    endpoint: null
  },

  // ============================================================
  // 📣 SECCIÓN CTA (Llamada a la acción)
  // ============================================================
  cta: {
    title: "¿Listo para dar el siguiente paso?",
    subtitle: "Obtén tu crédito hoy y haz realidad tus planes. Atención presencial, rápida y segura.",
    primaryButton: "Solicita tu crédito ahora",
    secondaryButton: "Habla con un asesor"
  },

  // ============================================================
  // 🦶 FOOTER
  // ============================================================
  footer: {
    description: "Tu aliado financiero de confianza. Ofrecemos soluciones crediticias personalizadas para impulsar tus metas.",
    
    // Enlaces rápidos
    quickLinks: {
      title: "Enlaces rápidos",
      items: [
        { text: "¿Quiénes somos?", href: "#quienes-somos" },
        { text: "Nuestros créditos", href: "#creditos" },
        { text: "FAQ", href: "#faq" },
        { text: "Contacto", href: "#contacto" }
      ]
    },
    
    // Productos
    productsLinks: {
      title: "Productos",
      items: [
        "Crédito de Nómina",
        "Crédito Personal",
        "Crédito Empresarial",
        "Factoraje"
      ]
    },
    
    copyright: "CONFIARÉ. Todos los derechos reservados.",
    privacyLink: {
      text: "Aviso de Privacidad",
      href: "/aviso-de-privacidad"
    }
  },

  // ============================================================
  // 📱 HEADER / NAVEGACIÓN
  // ============================================================
  navigation: {
    links: [
      { name: "Inicio", href: "#inicio" },
      { name: "¿Quiénes somos?", href: "#quienes-somos" },
      { name: "Créditos", href: "#creditos" },
      { name: "FAQ", href: "#faq" },
      { name: "Contacto", href: "#contacto" },
      { name: "Aviso de privacidad", href: "/aviso-de-privacidad", isExternal: true }
    ],
    ctaButton: "Solicitar crédito"
  }

};

// ============================================================
// EXPORTACIÓN - NO MODIFICAR
// ============================================================
export default siteContent;

// Exportaciones individuales para compatibilidad
export const {
  seo,
  contact,
  socialLinks,
  institutionalLinks,
  images,
  hero,
  products,
  benefits,
  about,
  process,
  faq,
  une,
  contactForm,
  cta,
  footer,
  navigation
} = siteContent;
